import React from 'react';
import { Col, Row } from 'antd';
import { accAdd, matchNumber, accSub } from '../../../../util/math';
import '../../style.less';

const base_title = {
  container_last: '柜尾抽检/End of  the cabinet',
  container_middle: '柜中抽检/Middle of the cabinet',
  container_head: '柜头抽检/The head of the cabinet',
};
const COLOR = {//颜色
  '1号色果皮青绿': '1号色果皮青绿/No.1 color',
  '2号色果皮黄绿': '2号色果皮黄绿/No.2 color',
  '3号色果尖黄色': '3号色果尖黄色/No.3 color',
  '4号色果皮转黄色': '4号色果皮转黄色/No.4 color',
  '5号色果皮亮黄色': '5号色果皮亮黄色/No.5 color'
};
const FleshHardness = {//果肉硬度 果壳硬度
  '软': '软/Soft',
  '微软': '微软/Slightly soft',
  '硬': '硬/Hard',
  '微硬': '微硬/Slightly hard'

};
const FleshTexture = {//果肉口感
  '软糯香甜': '软糯香甜/Fragrant and sweet',
  '甘甜': '甘甜/Sweetness',
  '苦甜': '苦甜/Bitter-sweet',
  '甜中微涩': '甜中微涩/Sweet with a slight astringency',
  '苦': '苦/Bitter'
};
const Fruity = {//果味
  '奶油味': '奶油味/Creamy',
  '草药味': '草药味/Herbal smell',
  '酒香味': '酒香味/Wine Aroma',
  '无味': '无味/Odorless'
};
const FruitColor = {//果色
  '乳白色': '乳白色/Milk white',
  '微黄': '微黄/Slightly yellow',
  '中黄': '中黄/Middle Yellow',
  '深黄': '深黄/Deep yellow'

};
const IsOpen = {//是否开果
  '开果': '开果/Yes',
  '未开果': '未开果/No'
};
const category_list = [
  {
    name: '榴莲',
    value: 1
  },
  {
    name: '山竹',
    value: 2
  },
  {
    name: '龙眼',
    value: 3
  },
  {
    name: '椰青',
    value: 4
  },
  {
    name: '青柚',
    value: 5
  },
  {
    name: '火龙果',
    value: 6
  },
];
function formatNumber(num1, num2) {
  return !isNaN(num1 / num2) && num1 > 0 && num2 > 0 ? (((num1 / num2) * 100).toFixed(2)) : '';
}
export default function PrintItem(props) {
  const { info = {}, currentKey = '', category = 1 } = props;
  let sum = 0, sweetSum = 0;
  let count = 0, sweetCount = 0, average = 0;
  if (+category === 6) {
    for (let key in info?.singleWeight) {
      if (info?.singleWeight.hasOwnProperty(key)) {
        sum += info?.singleWeight[key].weight;
        count++;
      }
    }
    average = sum / count;//平均重量
  }
  for (let key in info?.sweet) {
    if (info?.sweet.hasOwnProperty(key)) {
      sweetSum += info?.sweet[key].sweetness;
      sweetCount++;
    }
  }

  let averageSweet = sweetSum / sweetCount;//平均糖度

  const renderBase = (title, key) => {
    return <Col span={8} key={key}>
      <div>
        <span>{title}：{info?.[key]?.number}个</span>
        <span className='port-quality-report-item-span'>          占比/proportion：{formatNumber(info?.[key]?.number, info?.sampling?.thing_number)}%</span>
      </div>
      <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
        {(info?.[key]?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
      </div>
    </Col>;
  };

  const totalForArray = arr => arr.length ? arr.reduce((a, b) => accAdd(a, b), 0) : '';

  const averageForArray = (weight, packaging_weight) => {
    const arr = Object.values(weight || {}).map(item => item.weight);

    if (arr.length) {
      const total = totalForArray(arr), weight = +matchNumber(packaging_weight);
      return (!isNaN(total) ? (accSub(total, weight * arr.length) / arr.length).toFixed(3) : '');
    }
  };

  return (
    <div className='port-quality-report-base'>
      <div className='port-quality-report-title'>{base_title[currentKey]}</div>
      <div className='port-quality-report-item'>
        <div>{category_list.find(item => item.value === +category)?.name}{+category === 2 ? '外观' : ''}图片</div>
        <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
          {(info?.product_pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
        </div>
      </div>
      {(+category === 2) &&
        <div className='port-quality-report-item'>
          <div>{category_list.find(item => item.value === +category)?.name}{+category === 2 ? '内部果肉' : ''}图片</div>
          <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
            {(info?.interior_pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
          </div>
        </div>
      }
      <Row className='port-quality-report-item'>
        <Col span={8}>抽样/Sample number：{info?.sampling?.packing_number}箱    共计：{info?.sampling?.thing_number}个</Col>
        {+category === 5 && <>{[{ title: '坏果', key: 'bad_fruit' },].map(item => renderBase(item.title, item.key))}</>}
      </Row>
      {
        [1, 2, 3, 4].includes(+category) && <Row className='port-quality-report-item'>
          {Reflect.ownKeys(info?.weighing).map((key, index) => <Col span={12} key={key}>
            <div>称重{index + 1}/Weight {index + 1}：{info?.weighing?.[key]?.weight}kg</div>
            <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
              {(info?.weighing?.[key]?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
            </div>
          </Col>)
          }
        </Row>
      }
      {
        +category === 1 && <>
          <Row className='port-quality-report-item'>
            <Col span={8}>
              <div>包装重量：{info?.packaging_weight}</div>
            </Col>
            <Col span={8}>
              {/* <div>平均净重：{averageForArray([info?.weighing?.weight_1?.weight, info?.weighing?.weight_2?.weight, info?.weighing?.weight_3?.weight], info?.packaging_weight)}kg</div> */}
              <div>平均净重：{averageForArray(info?.weighing, info?.packaging_weight)}kg</div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={12}>
              <div>果心温度1/Temperature in pulp 1：{info?.core_temperature?.temperature}℃</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.core_temperature?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' src={item} alt='' />)}
              </div>
            </Col>
            <Col span={12}>
              <div>果心温度2/Temperature in pulp 2：{info?.core_temperature2?.temperature}℃</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.core_temperature2?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' src={item} alt='' />)}
              </div>
            </Col>
            <Col span={12}>
              <div>果心温度3/Temperature in pulp 3：{info?.core_temperature3?.temperature}℃</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.core_temperature3?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' src={item} alt='' />)}
              </div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={8}>
              <div>整体果色/Color：{COLOR[info?.color]}</div>
            </Col>
            <Col span={8}>
              <div>果壳硬度/Shell hardness：{FleshHardness[info?.shell_hardness]}</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.shell_hardness_videos || []).map((item, index) => <video key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'video' })} src={item} alt='' />)}
              </div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={8}>
              <div>
                <span>果皮裂口/Crack Number：{info?.fissure?.number}个</span>
                <span className='port-quality-report-item-span'>          占比/proportion：{formatNumber(info?.fissure?.number, info?.sampling?.thing_number)}%</span>
              </div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.fissure?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={8}>
              <div>
                <span>发霉/Mildew Number：{info?.moldy?.number}个</span>
                <span className='port-quality-report-item-span'>          占比/proportion：{formatNumber(info?.moldy?.number, info?.sampling?.thing_number)}%</span>
              </div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.moldy?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={8}>
              <div>
                <span>烂刺/Rotten Sting Number：{info?.rotten?.number}个</span>
                <span className='port-quality-report-item-span'>          占比/proportion：{formatNumber(info?.rotten?.number, info?.sampling?.thing_number)}%</span>
              </div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.rotten?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={8}>
              <div>是否开果/Does it bear fruit：{IsOpen[info?.open_fruit]}</div>
            </Col>
            <Col span={8}>
              <div>果肉硬度/Flesh hardness：{FleshHardness[info?.flesh_hardness]}</div>
            </Col>
            <Col span={8}>
              <div>果肉颜色/Flesh color：{FruitColor[info?.flesh_color]}</div>
            </Col>
            <Col span={24}>
              <div>糖度检测/Sugar content detection：{info?.sugar?.Brix} °Brix%</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.flesh_hardness_videos || []).filter(item => item).map((item, index) => <video key={index} width="70" height="70" className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'video' })}><source src={item} /></video>)}
                {(info?.flesh_hardness_pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={8}>
              <div>果肉口感/Flesh texture：{FleshTexture[info?.flesh_texture]}</div>
            </Col>
            <Col span={8}>
              <div>果味/Fruity：{Fruity[info?.flesh_taste]}</div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={8}>
              <div>
                <span>坏果/Bad Fruit：{info?.bad_fruit?.number}个</span>
                <span className='port-quality-report-item-span'>          占比/proportion：{formatNumber(info?.bad_fruit?.number, info?.sampling?.thing_number)}%</span>
              </div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.bad_fruit?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
          </Row>
        </>
      }
      {
        +category === 2 && <>
          <Row className='port-quality-report-item'>
            <Col span={24}>
              <div>糖度检测/Sugar content detection：{info?.sugar?.Brix} °Brix%</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.sugar?.videos || []).filter(item => item).map((item, index) => <video key={index} width="70" height="70" className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'video' })}><source src={item} /></video>)}
                {(info?.sugar?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            {[{ title: '内部腐烂', key: 'internal_rot' }, { title: '糖心果肉', key: 'candy_pulp' }, { title: '山竹胶掉落', key: 'drops' }, { title: '碰伤裂果死竹', key: 'bruised' }, { title: '虫果', key: 'insect' }, { title: '腐烂发霉', key: 'moldy' },].map(item => renderBase(item.title, item.key))}
          </Row>
        </>
      }
      {
        +category === 3 && <>
          <Row className='port-quality-report-item'>
            <Col span={24}>
              <div>糖度检测/Sugar content detection：{info?.sugar?.Brix} °Brix%</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.sugar.videos || []).filter(item => item).map((item, index) => <video key={index} width="70" height="70" className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'video' })}><source src={item} /></video>)}
                {(info?.sugar.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            {[{ title: '红头和白头', key: 'red_and_white_head' }, { title: '发芽', key: 'germination' }, { title: '腐烂发霉有虫', key: 'rotten_moldy_and_wormy' }, { title: '果皮破损挤坏', key: 'peel_damaged_and_crushed' }].map(item => renderBase(item.title, item.key))}
          </Row>
        </>
      }
      {
        +category === 4 && <>
          <Row className='port-quality-report-item'>
            <Col span={24}>
              <div>糖度检测/Sugar content detection：{info?.sugar?.Brix} °Brix%</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.sugar.videos || []).filter(item => item).map((item, index) => <video key={index} width="70" height="70" className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'video' })}><source src={item} /></video>)}
                {(info?.sugar.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            {[{ title: '紫斑或昆虫斑点', key: 'purple_or_insect_spots' }, { title: '裂纹', key: 'crack' }, { title: '瘀伤', key: 'bruises' }, { title: '形状不规则', key: 'irregular_shape' }, { title: '包装收缩膜受损', key: 'packaging_shrink_film_damaged' }, { title: '开口器缺陷', key: 'opener_defect' }, { title: '发霉腐烂', key: 'moldy_and_rotten' }, { title: '无水或无肉', key: 'no_water_or_meat' }, { title: '椰汁变色变质', key: 'coconut_milk_changes_color_and_goes_bad' },].map(item => renderBase(item.title, item.key))}
          </Row>
        </>
      }
      {
        +category === 6 ? <>
          <Row className='port-quality-report-item'>
            <Col span={8}>
              <div>
                <span>毛重：{info?.gross_weight?.number}个</span>
                <span className='port-quality-report-item-span'>          KG</span>
              </div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.gross_weight?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={8}>
              <div>
                <span>平均重量：{info?.gross_weight?.number / info?.sampling?.thing_number}KG/个</span>
              </div>
            </Col>
            <Col span={8}>
              <div>
                <span>包装是否齐全：{info?.packaging_complete}</span>
              </div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={12}>
              <div>
                <span>严重缺陷（机械伤害、挤压伤、收缩、果蒂撕裂）：{info?.serious_defect?.number}个</span>
                <span className='port-quality-report-item-span'>          占比/proportion：{formatNumber(info?.serious_defect?.number, info?.sampling?.thing_number)}%</span>
              </div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.serious_defect?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={12}>
              <div>
                <span>一般缺陷（黄色/红色棘、皮肤缺陷、白点、柔软）：{info?.general_defect?.number / info?.sampling?.thing_number}个</span>
                <span className='port-quality-report-item-span'>          占比/proportion：{formatNumber(info?.general_defect?.number, info?.sampling?.thing_number)}%</span>
              </div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.general_defect?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={12}>
              <div>单果称重1:  {info?.singleWeight?.weight_1?.weight}kg</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.singleWeight?.weight_1?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={12}>
              <div>单果称重2:   {info?.singleWeight?.weight_2?.weight}kg</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.singleWeight?.weight_2?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={12}>
              <div>单果称重3:  {info?.singleWeight?.weight_3?.weight}kg</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.singleWeight?.weight_3?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={12}>
              <div>平均重量:  {average}kg</div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={12}>
              <div>糖度1:  {info?.sweet?.sweetness_1?.sweetness}%</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.sweet?.sweetness_1?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={12}>
              <div>糖度2:  {info?.sweet?.sweetness_2?.sweetness}%</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.sweet?.sweetness_2?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
          </Row>
          <Row className='port-quality-report-item'>
            <Col span={12}>
              <div>糖度3:  {info?.sweet?.sweetness_3?.sweetness}%</div>
              <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
                {(info?.sweet?.sweetness_3?.pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
              </div>
            </Col>
            <Col span={12}>
              <div>平均糖度:  {averageSweet}%</div>
            </Col>
          </Row>
        </> : ''
      }
      <Row className='port-quality-report-item'>
        <Col span={24}>备注/remarks：{info?.remarks?.remarks_text}</Col>
      </Row>
      <Row className='port-quality-report-item'>
        <Col span={24}>
          <div className='port-quality-report-item-imgs port-quality-report-item-imgs_print'>
            {(info?.remarks?.remarks_videos || []).filter(item => item).map((item, index) => <video key={index} width="70" height="70" className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'video' })}><source src={item} /></video>)}
            {(info?.remarks?.remarks_pictures || []).filter(item => item).map((item, index) => <img key={index} className='port-quality-report-item-img' onClick={() => props.showModal({ item, type: 'image' })} src={item} alt='' />)}
          </div>
        </Col>
      </Row>
    </div>
  );
}
